import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CollectingStatesService } from '../collecting-states.service';
import { CollectingActionsService } from '../collecting-actions.service';
import { TaskFailedModalService } from '../../shared/task-failed-modal/task-failed-modal.service';
import { IOrdersService, ORDERS_SERVICE_IMPL } from 'shared';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-collecting-buttons',
    templateUrl: './collecting-buttons.component.html',
    styleUrls: ['./collecting-buttons.component.scss'],
})
export class CollectingButtonsComponent implements OnInit {
    @ViewChild('wrapperHelper', { static: false }) wrapperHelper: ElementRef;
    private customerCalledSubscription = new Subscription();

    constructor(
        public states: CollectingStatesService,
        public actions: CollectingActionsService,
        public taskFailedModalService: TaskFailedModalService,
        @Inject(ORDERS_SERVICE_IMPL)
        private _ordersService: IOrdersService
    ) {}

    ngOnInit(): void {}

    get isCallCustomerButtonVisible(): boolean {
        return (
            this.states.existPreferenceSettings &&
            this.states.showPhoneButton &&
            !this.states.customerCalled
        );
    }

    public callDone(): void {
        this.customerCalledSubscription = this._ordersService
            .setCustomerCalled(this.states.orderID)
            .subscribe(
                (resp) => {
                    if (resp.status === 200) {
                        this.states.customerCalled = true;
                    }
                },
                (error) => {
                    console.error(error.message);
                },
                () => {
                    this.states.customerCalled = true;

                    this.wrapperHelper.nativeElement.click();
                    this.customerCalledSubscription.unsubscribe();
                }
            );
    }
}
